// AbMonitoring — Sub-View "Monitoring" (ADMIN-only, Route bereits in AbShell/AbSidebar gegated).
// 5 Tabs: Mail | Extraktion | KI | Aktionen | Gemeldet (Vorbild OC-Pilot pages/Monitoring.tsx).
// Direktaufruf durch Nicht-Admins wird zusaetzlich HIER abgefangen (Verteidigung in der Tiefe,
// falls die Sidebar uebersprungen wird) — Muster OC-Pilot Monitoring().

import React, { useState } from 'react';
import { Mail, ScanText, Sparkles, ListTree, Flag } from 'lucide-react';
import AbMonitoringMailTab from './monitoring/AbMonitoringMailTab';
import AbMonitoringExtractionTab from './monitoring/AbMonitoringExtractionTab';
import AbMonitoringLlmTab from './monitoring/AbMonitoringLlmTab';
import AbMonitoringActionsTab from './monitoring/AbMonitoringActionsTab';
import AbMonitoringReportedTab from './monitoring/AbMonitoringReportedTab';

const TABS = [
  { id: 'mail', icon: Mail, labelKey: 'ab.shell.monTabMail' },
  { id: 'extraction', icon: ScanText, labelKey: 'ab.shell.monTabExtraction' },
  { id: 'llm', icon: Sparkles, labelKey: 'ab.shell.monTabLlm' },
  { id: 'actions', icon: ListTree, labelKey: 'ab.shell.monTabActions' },
  { id: 'reported', icon: Flag, labelKey: 'ab.shell.monTabReported' },
];

const AbMonitoring = ({ user, isDarkMode, t, onOpenDocument, showSuccess, showError }) => {
  const [tab, setTab] = useState('mail');
  const isAdmin = user?.role === 'admin';

  if (!isAdmin) {
    return (
      <div className={`rounded-2xl p-5 text-sm ${isDarkMode ? 'bg-red-500/15 text-red-300 border border-red-500/25' : 'bg-red-50 text-red-600 border border-red-200'}`}>
        {t('ab.shell.monNoAccess')}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className={`text-lg font-bold ${isDarkMode ? 'text-white/90' : 'text-slate-900'}`}>{t('ab.shell.monitoringTitle')}</h2>
        <p className={`text-xs mt-0.5 ${isDarkMode ? 'text-white/50' : 'text-slate-500'}`}>{t('ab.shell.monitoringSubtitle')}</p>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        {TABS.map(({ id, icon: Icon, labelKey }) => (
          <button key={id} type="button" onClick={() => setTab(id)}
            className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl text-sm font-medium transition-all ${tab === id
              ? (isDarkMode ? 'bg-indigo-600/70 text-white border border-indigo-400/30' : 'bg-indigo-600 text-white')
              : (isDarkMode ? 'text-white/60 hover:text-white hover:bg-white/10' : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100')
            }`}>
            <Icon className="w-4 h-4" />{t(labelKey)}
          </button>
        ))}
      </div>

      <div className={`rounded-2xl p-5 ${isDarkMode ? 'bg-white/[0.06] border border-white/[0.12]' : 'bg-white border border-slate-200 shadow-sm'}`}>
        {tab === 'mail' && <AbMonitoringMailTab user={user} isDarkMode={isDarkMode} t={t} onOpenDocument={onOpenDocument} showError={showError} />}
        {tab === 'extraction' && <AbMonitoringExtractionTab user={user} isDarkMode={isDarkMode} t={t} onOpenDocument={onOpenDocument} showError={showError} />}
        {tab === 'llm' && <AbMonitoringLlmTab user={user} isDarkMode={isDarkMode} t={t} onOpenDocument={onOpenDocument} showError={showError} />}
        {tab === 'actions' && <AbMonitoringActionsTab user={user} isDarkMode={isDarkMode} t={t} onOpenDocument={onOpenDocument} showError={showError} />}
        {tab === 'reported' && (
          <AbMonitoringReportedTab
            user={user} isDarkMode={isDarkMode} t={t} isAdmin={isAdmin}
            onOpenDocument={onOpenDocument} showSuccess={showSuccess} showError={showError}
          />
        )}
      </div>
    </div>
  );
};

export default AbMonitoring;
